import { render } from "./RelationSummaryCard.vue?vue&type=template&id=399cb9ee"
import script from "./RelationSummaryCard.vue?vue&type=script&lang=js"
export * from "./RelationSummaryCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__